import SideMenu from '@/containers/side-menu/SideMenu.vue'
import Reversal from '@/pages/reversal/Reversal'

export default {
  path: '/reversal',
  name: 'Reversal',
  components: {
    mainContent: Reversal,
    mainMenu: SideMenu
  },
  meta: {
    role: {
      sectorId: 'vehicle-reversal'
    },
    breadcrumb: {
      title: 'Estorno no Veículo',
      paths: [
        { title: 'Estorno no Veículo' }
      ]
    }
  }
}